import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"
import { RoomType } from "shared/types/references/RoomType"

export const InstallationReferenceObjClass = Scrivito.provideObjClass(
  "InstallationReference",
  {
    attributes: {
      ...defaultPageAttributes,
      roomImage: ["reference", { only: "Image" }],
      roomImageWidget: ["widgetlist", { only: "ImageWidget" }],
      detailImage: ["reference", { only: "Image" }],
      detailImageWidget: ["widgetlist", { only: "ImageWidget" }],
      product: ["reference", { only: ["Product", "ProductBaseVariant"] }],
      roomType: ["multienum", { values: Object.values(RoomType) }],
      referenceID: "string"
    }
  }
)

export type InstallationReferenceObj = InstanceType<
  typeof InstallationReferenceObjClass
>
